<brd-hero-image></brd-hero-image>
<brd-maintenance-alert></brd-maintenance-alert>
<div class="section-container" *ngIf="homeData$ | async as homeData">
  <div class="section">
    <div class="container header">
      <div class="title">Active Demo Environments</div>
      <div class="description">
        Here you find all your User Group Active Demo Environments. Click on a tile or on the “Open” button to access the Demo Environment
        on another tab, or click on the different icons at the bottom of each tile to manage or delete the Demo Environments.
      </div>
    </div>
    <div class="container action">
      <brd-button
        id="create-demo-btn"
        text="create new demo"
        iconName="plus-16"
        (clickEvent)="createNewDemoClick()"
        [class]="{ 'btn-disabled': homeData.instancesQuotaExceeded || !homeData.defaultGroup }"
        [disabled]="homeData.instancesQuotaExceeded || !homeData.defaultGroup"
      ></brd-button>
      <div class="label-used-instances" *ngIf="homeData.limits as limit">{{ limit.currentUsage }}/{{ limit.limit }} used</div>
      <dx-select-box
        stylingMode="outlined"
        *ngIf="!!homeData.groups.length"
        [dataSource]="homeData.groups"
        displayExpr="text"
        valueExpr="groupName"
        [value]="homeData.selectedGroup"
        (onValueChanged)="onGroupChanged($event)"
        id="demos-groups"
        fieldTemplate="field"
      >
        <div *dxTemplate="let data of 'field'">
          <dx-text-box [value]="data?.text" [class]="{ 'default-group': data?.default }"></dx-text-box>
        </div>
        <div *dxTemplate="let data of 'item'" [class]="{ 'default-group': data?.default }">
          {{ data.text }}
        </div>
      </dx-select-box>
      <brd-button
        class="view-action"
        [iconName]="gridView() ? 'grid-column-24' : 'grid-area-24'"
        (clickEvent)="toggleView()"
        [matTooltip]="gridView() ? 'Grid view' : 'Tile view'"
      ></brd-button>
    </div>
    <ng-container *ngIf="!loading(); else loadingSpinner">
      <div class="container" *ngIf="gridView()">
        <div class="cards" *ngIf="homeData.instances.length; else noInstances">
          <brd-instance-tile
            *ngFor="let instance of homeData.instances"
            [instance]="instance"
            [canAccess]="homeData.defaultGroup"
          ></brd-instance-tile>
        </div>
        <ng-template #noInstances>
          <div class="no-instances">NO INSTANCES</div>
        </ng-template>
      </div>
      <div class="container grid" *ngIf="!gridView()">
        <brd-instance-grid [instances]="homeData.instances"></brd-instance-grid>
      </div>
    </ng-container>
  </div>
  <brd-demo-portfolio
    class="section demo-section"
    [defaultGroup]="homeData.defaultGroup"
    [instancesQuotaExceeded]="homeData.instancesQuotaExceeded"
  ></brd-demo-portfolio>
</div>
<brd-contact-support></brd-contact-support>
<ng-template #loadingSpinner>
  <div class="container loader">
    <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
  </div>
</ng-template>
